import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Graphics } from '@inlet/react-pixi';
import { useMemo } from 'react';
import ChatContactFormModal from 'components/powerChatFlow/containers/modals/contactform';
import { useFindQueue } from 'components/powerFlowShared/hooks/useFindQueue';
import { usePixiBadge } from 'components/powerFlowShared/hooks/usePixiBadge';
import { ContactFormModal as MessangerContactFormModal } from 'components/settings/components/sections/dixaMessenger/views/flow/components/nodeTypeContactForm/components/contactFormModal';
import { flowNodeColor, FlowType } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
const getContactFormModal = (type) => {
    switch (type) {
        case FlowType.FLOW_TYPE_CHAT:
            return ChatContactFormModal;
        case FlowType.FLOW_TYPE_MESSENGER:
            return MessangerContactFormModal;
        default:
            return () => null;
    }
};
export const createContactFormNodeAttributes = (type) => ({
    iconName: 'chat-widget',
    label: 'Contact form',
    color: hexStringToNumber(flowNodeColor.green),
    translatePayload: () => [],
    updateConnection: (node) => node,
    NodeContent: ContactFormNode,
    ActionModal: getContactFormModal(type),
});
export function ContactFormNode({ node, context, }) {
    const { extraData } = context;
    const { payload } = node;
    const queue = useFindQueue(payload.queue, extraData);
    const drawArchivedBadge = usePixiBadge({
        text: 'Archived',
        variant: 'error',
        offset: { x: 0, y: 28 },
    });
    return (_jsx(TextContent, { children: useMemo(() => {
            var _a, _b;
            return (_jsxs(_Fragment, { children: [_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Queue" }), _jsx(Text, { weight: "semibold", text: (_b = (_a = queue === null || queue === void 0 ? void 0 : queue.name) !== null && _a !== void 0 ? _a : payload.queue.label) !== null && _b !== void 0 ? _b : 'No queue selected' })] }), (queue === null || queue === void 0 ? void 0 : queue.is_archived) && _jsx(Graphics, { draw: drawArchivedBadge })] }));
        }, [drawArchivedBadge, payload.queue, queue]) }));
}
export const ContactFormNodeChatAttributes = createContactFormNodeAttributes(FlowType.FLOW_TYPE_CHAT);
export const ContactFormNodeMessengerAttributes = createContactFormNodeAttributes(FlowType.FLOW_TYPE_MESSENGER);
